<template>
    <div>
        <InputField
            v-if="$props.type == 'string' && $props.filterType != 'inner'"
            v-model="currentValue"
            :label="$props.text"
            @change.native="callChange"
        ></InputField>
        <InputField
            v-if="$props.type == 'string' && $props.filterType == 'inner'"
            v-model="currentValue"
            @change.native="callChange"
        ></InputField>

        <CurrencyField
            v-if="$props.type == 'price' && $props.filterType != 'inner'"
            v-model="currentValue"
            :label="$props.text"
            @change.native="callChange"
        ></CurrencyField>
        <CurrencyField
            v-if="$props.type == 'price' && $props.filterType == 'inner'"
            v-model="currentValue"
            :label="$props.text"
            class="currency-simple"
            @change.native="callChange"
        ></CurrencyField>

        <CurrencyField
            v-if="$props.type == 'price_range'"
            v-model="currentValue['from']"
            :label="$props.text + ' ' + $t('labels.from')"
            @change.native="callChange"
        ></CurrencyField>
        <div v-if="$props.type == 'price_range'">&nbsp;</div>
        <CurrencyField
            v-if="$props.type == 'price_range'"
            v-model="currentValue['to']"
            :label="$props.text + ' ' + $t('labels.to')"
            @change.native="callChange"
        ></CurrencyField>

        <Dropdown
            v-if="$props.type.includes('dropdown') && $props.filterType != 'inner'"
            v-model="currentValue"
            :ajax="true"
            :clearable="true"
            :data="dropdownUrl"
            :label="$props.text"
            @changes="callChange"
        ></Dropdown>
        <Dropdown
            v-if="$props.type.includes('dropdown') && $props.filterType === 'inner'"
            v-model="currentValue"
            :ajax="true"
            :clearable="true"
            :data="dropdownUrl"
            class="dropdown-simple"
            @changes="callChange"
        ></Dropdown>

        <DropdownMultiple
            v-if="$props.type.includes('multiple') && $props.filterType != 'inner'"
            v-model="currentValue"
            :ajax="true"
            :data="dropdownUrl"
            :label="$props.text"
            @changes="callChange"
        >
        </DropdownMultiple>

        <DropdownMultiple
            v-if="$props.type.includes('multiple') && $props.filterType === 'inner'"
            v-model="currentValue"
            :ajax="true"
            :data="dropdownUrl"
            @changes="callChange"
        >
        </DropdownMultiple>

        <Tags
            v-if="$props.type.includes('tags')"
            v-model="currentValue"
            :ajax="true"
            :data="dropdownUrl"
            :label="$props.text"
            @changes="callChange"
        ></Tags>

        <DatePicker
            v-if="$props.type == 'date' && $props.filterType !== 'inner'"
            v-model="currentValue"
            :clearable="true"
            :dateLabel="''"
            @changes="callChange"
        />
        <DatePicker
            v-if="$props.type == 'date' && $props.filterType === 'inner'"
            v-model="currentValue"
            :clearable="true"
            :dateLabel="''"
            @changes="callChange"
        />

        <DatePicker
            v-if="$props.type == 'date_range'"
            v-model="currentValue['from']"
            :clearable="true"
            :dateLabel="$props.text + ' ' + $t('labels.from')"
            @changes="callChange"
        />
        <div v-if="$props.type == 'date_range'">&nbsp;</div>
        <DatePicker
            v-if="$props.type == 'date_range'"
            v-model="currentValue['to']"
            :clearable="true"
            :dateLabel="$props.text + ' ' + $t('labels.to')"
            @changes="callChange"
        />

        <DatePicker
            v-if="$props.type == 'placement_sign_on_date_range'"
            v-model="currentValue['from']"
            :clearable="true"
            :dateLabel="$t('labels.startDate')"
            @changes="callChange"
        />
        <div v-if="$props.type == 'placement_sign_on_date_range'">&nbsp;</div>
        <DatePicker
            v-if="$props.type == 'placement_sign_on_date_range'"
            v-model="currentValue['to']"
            :clearable="true"
            :dateLabel="$t('labels.endDate')"
            @changes="callChange"
        />

        <v-radio-group
            v-if="$props.type == 'boolean' && $props.filterType != 'inner'"
            v-model="currentValue"
            @click.native="callChange"
        >
            <template slot="label"> {{ $props.text }}: </template>
            <v-radio :label="$t('buttons.yes')" :value="true"></v-radio>
            <v-radio :label="$t('buttons.no')" :value="false"></v-radio>
            <v-radio :label="$t('buttons.all')" :value="null"></v-radio>
        </v-radio-group>
        <Dropdown
            v-if="$props.type == 'boolean' && $props.filterType === 'inner'"
            v-model="currentValue"
            :ajax="false"
            :clearable="false"
            :data="booleanData"
            @changes="callChange"
        ></Dropdown>

        <v-radio-group
            v-if="$props.type == 'boolean_partial' && $props.filterType != 'inner'"
            v-model="currentValue"
            @click.native="callChange"
        >
            <template slot="label"> {{ $props.text }}: </template>
            <v-radio :label="$t('buttons.yes')" :value="1"></v-radio>
            <v-radio :label="$t('buttons.no')" :value="0"></v-radio>
            <v-radio :label="$t('buttons.all')" :value="null"></v-radio>
            <v-radio :label="$t('buttons.partial')" :value="2"></v-radio>
        </v-radio-group>
        <Dropdown
            v-if="$props.type == 'boolean_partial' && $props.filterType === 'inner'"
            v-model="currentValue"
            :ajax="false"
            :clearable="false"
            :data="booleanPartialData"
            simple
            class="dropdown-simple"
            @changes="callChange"
        ></Dropdown>
    </div>
</template>

<script>
import CurrencyField from './CurrencyField';
import DatePicker from './DatePicker';
import InputField from './InputField';
import Dropdown from './Dropdown';
import DropdownMultiple from './DropdownMultiple';
import Tags from './Tags';

export default {
    name: 'FilterField',
    components: {DatePicker, InputField, CurrencyField, Dropdown, Tags, DropdownMultiple},
    props: ['value', 'text', 'type', 'name', 'filterType'],
    data() {
        return {
            currentValue: this.$props.value.raw,
            booleanData: [
                {
                    label: this.$t('buttons.yes'),
                    value: true,
                },
                {
                    label: this.$t('buttons.no'),
                    value: false,
                },
                {
                    label: this.$t('buttons.all'),
                    value: null,
                },
            ],
            booleanPartialData: [
                {
                    label: this.$t('buttons.yes'),
                    value: 1,
                },
                {
                    label: this.$t('buttons.no'),
                    value: 0,
                },
                {
                    label: this.$t('buttons.all'),
                    value: null,
                },
                {
                    label: this.$t('buttons.partial'),
                    value: 2,
                },
            ],
            readyToShow: false,
            dropdownData: [],
        };
    },
    computed: {
        dropdownUrl() {
            if (!this.$props.type.includes('|')) {
                return null;
            }
            return this.$props.type.split('|')[1];
        },
    },
    watch: {
        currentValue: {
            handler: function () {
                let displayValue = this.currentValue;

                if (this.$props.type == 'price_range') {
                    displayValue = this.currentValue.from + ' - ' + this.currentValue.to;
                    if (this.currentValue.from === null) {
                        displayValue = '< ' + this.currentValue.to;
                    }
                    if (this.currentValue.to === null) {
                        displayValue = '> ' + this.currentValue.from;
                    }
                    if (this.currentValue.from === null && this.currentValue.to === null) {
                        displayValue = '';
                    }
                }

                if (this.$props.type.includes('dropdown')) {
                    for (let data of this.dropdownData) {
                        if (data.value == this.currentValue) {
                            displayValue = data.label;
                        }
                    }
                }

                if (this.$props.type.includes('multiple')) {
                    displayValue = [];
                    for (let selected of this.currentValue) {
                        let selectedDisplay = null;
                        for (let data of this.dropdownData) {
                            if (data.value == selected) {
                                selectedDisplay = data.label;
                            }
                        }
                        if (selectedDisplay !== null) {
                            displayValue.push(selectedDisplay);
                        }
                    }
                    displayValue = displayValue.join(', ');
                }

                if (this.$props.type.includes('tags')) {
                    displayValue = this.currentValue.join(', ');
                }

                if (this.$props.type == 'date') {
                    displayValue = this.parseDate(this.currentValue);
                }

                if (this.$props.type == 'date_range' || this.$props.type == 'placement_sign_on_date_range') {
                    let fromDisplay = this.parseDate(this.currentValue.from);
                    let toDisplay = this.parseDate(this.currentValue.to);
                    displayValue = fromDisplay + ' - ' + toDisplay;
                    if (fromDisplay == '') {
                        displayValue = '< ' + toDisplay;
                    }
                    if (toDisplay == '') {
                        displayValue = '> ' + fromDisplay;
                    }
                    if (fromDisplay == '' && toDisplay == '') {
                        displayValue = '';
                    }
                }

                if (this.$props.type == 'boolean') {
                    if (this.currentValue === true) displayValue = 'Da';
                    if (this.currentValue === false) displayValue = 'Ne';
                    if (this.currentValue === null) displayValue = 'Svi';
                }

                if (this.$props.type == 'boolean_partial') {
                    if (this.currentValue === 1) displayValue = 'Da';
                    if (this.currentValue === 0) displayValue = 'Ne';
                    if (this.currentValue === 2) displayValue = 'Djelomično';
                    if (this.currentValue === null) displayValue = 'Svi';
                }

                this.$emit('input', {
                    raw: this.currentValue,
                    display: displayValue,
                });
            },
            deep: true,
        },
        value() {
            this.currentValue = this.$props.value.raw;
        },
    },
    methods: {
        callChange() {
            this.$emit('changes');
        },
        parseDate(date) {
            if (date == null) return '';
            const [year, month, day] = date.split('-');
            return `${parseInt(day)}.${parseInt(month)}.${year}.`;
        },
    },
    mounted() {
        if (this.dropdownUrl != null) {
            this.$APICall(
                'get',
                'select/' + this.dropdownUrl,
                {},
                (data, success) => {
                    if (success) {
                        this.dropdownData = data;
                    }
                },
                false,
            );
        }
    },
};
</script>

<style scoped>
.filter-enable-checkbox {
    max-width: 30px;
}
</style>
